import { useState, useEffect, useRef, useCallback } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   Button,
   Box,
   Flex,
   Text,
   HStack,
   Badge,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   ModalFooter,
   TableContainer,
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   AlertDialog,
   AlertDialogOverlay,
   AlertDialogContent,
   AlertDialogHeader,
   AlertDialogBody,
   AlertDialogFooter,
   Checkbox,
   Icon,
   Input,
   useDisclosure,
   Stack,
   useColorMode,
} from '@chakra-ui/react';
import { FaHistory } from 'react-icons/fa';
import { FaRupeeSign } from 'react-icons/fa';
import editIcon from '../../../../../assets/img/nfts/edit.svg';
import printIcon from '../../../../../assets/img/nfts/print.svg';
import dotIcon from '../../../../../assets/img/nfts/dot.svg';
import shareIcon from '../../../../../assets/img/nfts/share.svg';
import dwonloadIcon from '../../../../../assets/img/nfts/download.svg';
import copyIcon from '../../../../../assets/img/nfts/copy.svg';
import receiptIcon from '../../../../../assets/img/nfts/receipt.svg';
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import { useNavigate } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import PaymentcaseForm from 'views/admin/cash/PaymentcaseForm';
import { getAccountById } from '../../../../../redux/actions/account';
import { getSingleSaleInvoice } from '../../../../../redux/actions/salesInvoice';
import { useDispatch } from 'react-redux';
import JsBarcode from 'jsbarcode';
import { useUser, useGlobal } from '../../../../../contexts';
import html2canvas from 'html2canvas';
import IssuePurchaseEntriesModal from 'components/IssuePurchaseEntries/IssuePurchaseEntries';
import about from 'assets/img/nfts/about.svg';
import { addIssueReason } from '../../../../../redux/actions/issueInventory';
import { addReceiveReason } from '../../../../../redux/actions/receiveInventory';
import { DeleteIcon } from '@chakra-ui/icons';
import Swal from 'sweetalert2';

const SaleSingleDataView = ({
   isOpenSingleView,
   onClose,
   entityType,
   singleEntity,
   dynamicUserDetails,
   initialIndex,
   invoices,
   onEditFormClose,
   setIsOpenSingleView,
   setIsEditFormOpen,
   isEditFormOpen,
   title,
   singleEntityRights,
   handleViewSingleData,
}) => {
   const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
   const { isOpen: isOpenReturn, onOpen: onOpenReturn, onClose: onCloseReturn } = useDisclosure();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [isBankMenuOpen, setIsBankMenuOpen] = useState(false);
   const [isOpenPaymentForm, setIsOpenPaymentForm] = useState(false);
   const [transactionType, setTransactionType] = useState('payment');
   const [isBankPageView, setIsBankPageView] = useState(false);
   const dispatch = useDispatch();
   const [selectedRowId, setSelectedRowId] = useState(null);
   const [items, setItems] = useState([]); // State to store the list of items
   const dimension = '6*20 mm'; // State for dimension input
   const purchaseInvoice = entityType === 'purchaseinvoice';
   const [isIssuePurchaseModalOpen, setIsIssuePurchaseModalOpen] = useState(false);
   const [selectedItem, setSelectedItem] = useState(null);
   const [serialNo, setSerialNo] = useState(null);
   const [reason, setReason] = useState('');
   const [returnDate, setReturnDate] = useState('');
   const [lineDetailId, setLineDetailId] = useState(null);
   const { user } = useUser();
   // Track selected barcode items
   const [selectedBarcodeItems, setSelectedBarcodeItems] = useState([]);
   const Admin = user?.isAdmin;
   // Initialize with all items selected when invoice loads
   useEffect(() => {
      if (singleEntity?.lineitems?.length > 0) {
         // Initialize with all line items' serial numbers
         const initialSelectedItems = singleEntity.lineitems
            .filter(
               (item) =>
                  item?.purchaseLineDetail &&
                  Array.isArray(item.purchaseLineDetail) &&
                  item.purchaseLineDetail.length > 0,
            )
            .flatMap((item) =>
               item.purchaseLineDetail
                  .filter((detail) => detail?.serialNo)
                  .map((detail) => ({
                     id: detail.serialNo,
                     serialNo: detail.serialNo,
                     barcode: detail.barcode,
                     lineItemId: item.id || Math.random().toString(),
                     itemName: item.itemName,
                  })),
            );

         setSelectedBarcodeItems(initialSelectedItems);
      }
   }, [singleEntity]);

   // Toggle individual selection
   const handleCheckboxChange = (itemId, serialNo, barcode, lineItemId, itemName) => {
      setSelectedBarcodeItems((prevSelected) => {
         const isItemSelected = prevSelected.some((item) => item.id === itemId);

         if (isItemSelected) {
            return prevSelected.filter((item) => item.id !== itemId);
         } else {
            return [
               ...prevSelected,
               {
                  id: itemId,
                  serialNo,
                  barcode,
                  lineItemId,
                  itemName,
               },
            ];
         }
      });
   };

   // Check if an item is selected
   const isItemSelected = (serialNo) => {
      return selectedBarcodeItems.some((item) => item.id === serialNo);
   };

   // Toggle all selections
   const handleSelectAll = () => {
      if (selectedBarcodeItems.length === getTotalBarcodeItems()) {
         setSelectedBarcodeItems([]);
      } else {
         const allItems = singleEntity.lineitems
            .filter(
               (item) =>
                  item?.purchaseLineDetail &&
                  Array.isArray(item.purchaseLineDetail) &&
                  item.purchaseLineDetail.length > 0,
            )
            .flatMap((item) =>
               item.purchaseLineDetail
                  .filter((detail) => detail?.serialNo)
                  .map((detail) => ({
                     id: detail.serialNo,
                     serialNo: detail.serialNo,
                     barcode: detail.barcode,
                     lineItemId: item.id || Math.random().toString(),
                     itemName: item.itemName,
                  })),
            );

         setSelectedBarcodeItems(allItems);
      }
   };

   // Count total available barcode items
   const getTotalBarcodeItems = () => {
      if (!singleEntity?.lineitems) return 0;

      return singleEntity.lineitems
         .filter(
            (item) =>
               item?.purchaseLineDetail && Array.isArray(item.purchaseLineDetail) && item.purchaseLineDetail.length > 0,
         )
         .flatMap((item) => item.purchaseLineDetail.filter((detail) => detail?.serialNo)).length;
   };

   const handleBankPaymentClick = () => {
      // setIsBankMenuOpen(false);
      setIsOpenPaymentForm(true);
      setTransactionType('payment');
      setIsBankPageView(true);
   };

   const handleBankReceiveClick = () => {
      // setIsBankMenuOpen(false);
      setIsOpenPaymentForm(true);
      setTransactionType('receive');
      setIsBankPageView(true);
   };

   const handleCashPaymentClick = () => {
      setIsOpenPaymentForm(true);
      setTransactionType('payment');
      setIsBankPageView(false);
   };

   const handleCashReceiveClick = () => {
      setIsOpenPaymentForm(true);
      setTransactionType('receive');
      setIsBankPageView(false);
   };

   const cancelRef = useRef();
   const navigate = useNavigate();
   const getEditUrl = (entityType, entityId) => {
      switch (entityType) {
         case 'issuemaster':
            return `/admin/inventory/issue/edit/${entityId}`;
         case 'receivemaster':
            return `/admin/inventory/receive/edit/${entityId}`;
         default:
            throw new Error(`Invalid entity type: ${entityType}`);
      }
   };

   const handleEditClick = () => {
      setIsEditFormOpen(false);
      setIsOpenSingleView(false);

      localStorage.setItem('reopenSingleView', false);

      const editUrl = getEditUrl(entityType, singleEntity?.id);
      navigate(editUrl);
   };
   useEffect(() => {
      const shouldReopen = localStorage.getItem('reopenSingleView');

      if (shouldReopen) {
         setIsOpenSingleView(true);
         localStorage.removeItem('reopenSingleView');
      }
   }, []);

   const dynamicArray = [
      { label: 'Invoice Number', value: singleEntity?.docno || '-' },
      {
         label: 'Invoice Date',
         value: singleEntity?.transactionAt?.split('T')[0] || '-',
      },
      { label: 'Invoice Book', value: singleEntity?.daybookname || '-' },
      { label: 'Tax Type', value: singleEntity?.daybookno || '-' },
   ];

   const dynamicItemDetails = [
      {
         label: 'Item',
         value:
            singleEntity?.lineitems && singleEntity?.lineitems.length > 0 ? singleEntity?.lineitems[0].itemName : '-',
      },
      {
         label: 'Oty',
         value: singleEntity?.lineitems && singleEntity?.lineitems.length > 0 ? singleEntity?.lineitems[0].qty1 : '-',
      },
      {
         label: 'Rate',
         value:
            singleEntity?.lineitems && singleEntity?.lineitems.length > 0 ? singleEntity?.lineitems[0].itemRate : '-',
      },
      {
         label: 'Discount',
         value:
            singleEntity?.salebillteams && singleEntity?.salebillteams.length > 0
               ? singleEntity?.salebillteams[0].percentage
               : '',
      },
   ];

   const calculateTotal = (qty, rate, discount) => {
      const total = qty * rate;
      const discountAmount = (total / 100) * discount;
      return total - discountAmount;
   };

   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setIsDeleteDialogOpen(false);
   };

   const handleOnOpenModal = (serialNo) => {
      setSerialNo(serialNo);
   };

   const handleBarcodePrint = () => {
      if (!purchaseInvoice || selectedBarcodeItems.length === 0) return;

      // Create SVG barcodes for each selected serial number
      const barcodeItems = selectedBarcodeItems.map((item) => {
         const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

         JsBarcode(svgElement, item.serialNo.toString(), {
            format: 'CODE128',
            width: 1,
            height: 20,
            displayValue: true,
            fontSize: 0,
            margin: 0,
            textMargin: 0,
            xmlDocument: document,
         });

         const svgData = new XMLSerializer().serializeToString(svgElement);
         const barcodeDataUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgData);

         return {
            serialNumber: item.serialNo,
            dimensions: dimension,
            barcode: item.barcode,
            barcodeDataUrl: barcodeDataUrl,
         };
      });

      // Update state with selected items
      setItems(barcodeItems);

      // Print selected barcodes
      executePrintMultiple(barcodeItems);
   };

   const executePrintMultiple = (barcodeItems) => {
      // Create a print window
      const printWindow = window.open('', '_blank', 'height=auto,width=auto');

      // Create the HTML content with a 2x2 grid layout
      let contentHTML = `
            <html>
          <head>
            <title>Barcode Labels</title>
            <style>
              @page {
                size: 30mm 11mm; /* Size for 4 labels */
                margin: 0;
                padding: 0;
                // margin-left: 4mm;
              }
              body {
                margin: 0;
                padding: 0;
                display: flex;
                flex-wrap: wrap;
              }
              .label-container {
                width: 29mm;  //30mm - 30 size
                height: 11mm;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-top:8px;
               //  padding-bottom: 6px;
              }
              img {
                max-width: 24mm;  //25mm - 30 size
                max-height: 10mm;
                width: 100%;
                height: auto;
                margin-left: 2mm;  // cmt - 30 size
              }
              .serial-number {
                font-size: 4pt;  //4pt - 30 size
                text-align: center;
                // margin-left: 4mm;  // cmt - 30 size
              }
            </style>
          </head>
          <body>
       `;

      // Add each barcode label to the content
      barcodeItems.forEach((item, index) => {
         const paddingClass = index > 0 ? 'padding-top: "8px";' : '';
         contentHTML += `
           <div class="label-container" style="${paddingClass}">
             <img src="${item.barcodeDataUrl}" />
             <span class="serial-number">${item.barcode}</span>
           </div>
         `;
      });

      // Close the HTML content
      contentHTML += `
         </body>
         </html>
       `;

      // Write the content to the print window
      printWindow.document.write(contentHTML);
      printWindow.document.close();

      // Print after a short delay to ensure content is loaded
      setTimeout(() => {
         printWindow.print();
         setTimeout(() => {
            printWindow.close();
         }, 500);
      }, 300);
   };

   const handleCreateNote = () => {
      // create note
   };

   const handlePrevious = async () => {
      try {
         const previousId = singleEntity?.id - 1;
         await dispatch(getSingleSaleInvoice(previousId));
         const accountbyid = {
            id: Number(singleEntity?.accountId), // id must be number
            compId: String(user?.loginhistory?.companyId), // compId must be string
         };
         await dispatch(getAccountById(accountbyid));
         setIsOpenSingleView(true);
      } catch (error) {
         console.error('Error fetching previous sale data:', error);
      }
   };

   const handleNext = async () => {
      try {
         const nextId = singleEntity?.id + 1;
         await dispatch(getSingleSaleInvoice(nextId));
         const accountbyid = {
            id: Number(singleEntity?.accountId), // id must be number
            compId: String(user?.loginhistory?.companyId), // compId must be string
         };
         await dispatch(getAccountById(accountbyid));
         setIsOpenSingleView(true);
      } catch (error) {
         console.error('Error fetching next sale data:', error);
      }
   };

   const handlesave = async () => {
      // Wait for 500 milliseconds before calling
      await new Promise((resolve) => setTimeout(resolve, 500));
      handleViewSingleData(singleEntity.id);
   };

   // Update your component to use the handlePrintClick function

   const handlePrintClick = (singleEntity) => {
      // Formatting utility functions
      const formatCurrency = (value) => {
         if (!value) return '0.00';
         return parseFloat(value).toFixed(2);
      };

      const formatDate = (dateString) => {
         if (!dateString) return '';
         const date = new Date(dateString);
         return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
         });
      };

      const amountInWords = (amount) => {
         // Simple implementation - in a real app, use a proper library
         const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
         const teens = [
            'Ten',
            'Eleven',
            'Twelve',
            'Thirteen',
            'Fourteen',
            'Fifteen',
            'Sixteen',
            'Seventeen',
            'Eighteen',
            'Nineteen',
         ];
         const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

         // This is a simplified version - in production use a proper library
         if (amount < 1000) {
            return `${amount} Rupees Only`;
         } else {
            return `${Math.floor(amount / 1000)} Thousand ${amount % 1000} Rupees Only`;
         }
      };

      const getTaxRate = (item) => {
         if (!item) return '0%';
         const gstPercent = item.gstPercent || 0;
         return `${gstPercent}%`;
      };

      const getTaxType = (item) => {
         if (!item) return 'N/A';
         // Add proper tax type logic based on your data structure
         return item.typeOfSupply || 'Goods';
      };

      const getTaxAmount = (item) => {
         if (!item) return '0.00';
         const netGst = item.netGst || 0;
         return formatCurrency(netGst);
      };

      // Format dates
      const formattedTransactionDate = formatDate(singleEntity.transactionAt);
      const formattedCreatedAtnDate = formatDate(singleEntity.createdAt);

      // Calculate totals
      const totals = {
         totalTaxAmount: singleEntity.gstAmount || 0,
         grandTotal: singleEntity.netAmount || 0,
      };

      // Use the CSS data from singleEntity or use default CSS if not available
      const cssData =
         // singleEntity.cssData ||
         `
   body {
     font-family: Arial, sans-serif;
     margin: 0;
     padding: 0;
     color: #333;
     background-color: #fff;
   }
   
   .invoice-container {
     max-width: 900px;
     margin: 20px auto;
     padding: 20px;
     border: 1px solid #ddd;
     box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
   }
   
   .header {
     text-align: center;
     padding-bottom: 20px;
     border-bottom: 2px solid #eee;
   }
   
   .header h1 {
     margin: 0;
     font-size: 28px;
     color: #333;
     margin-bottom: 10px;
   }
   
   .header p {
     margin: 5px 0;
     font-size: 14px;
   }
   
   .invoice-details {
     display: flex;
     justify-content: space-between;
     margin: 20px 0;
     padding: 10px 0;
     border-bottom: 1px solid #eee;
   }
   
   .left-details, .right-details {
     width: 48%;
   }
   
   .left-details p, .right-details p {
     margin: 5px 0;
     font-size: 14px;
   }
   
   .items-table, .terms-table {
     width: 100%;
     border-collapse: collapse;
     margin: 20px 0;
   }
   
   .items-table th, .terms-table th {
     background-color: #f5f5f5;
     border: 1px solid #ddd;
     padding: 10px;
     text-align: left;
     font-size: 14px;
   }
   
   .items-table td, .terms-table td {
     border: 1px solid #ddd;
     padding: 8px;
     text-align: left;
     font-size: 13px;
   }
   
   .total-row {
     font-weight: bold;
     background-color: #f9f9f9;
   }
   
   .total-label {
     text-align: right;
   }
   
   .amount-label {
     text-align: right;
     font-weight: bold;
   }
   
   .amount-words {
     margin: 20px 0;
     padding: 10px;
     background-color: #f9f9f9;
     border-radius: 5px;
   }
   
   .amount-words p {
     margin: 5px 0;
     font-size: 14px;
   }
   
   .payment-details {
     margin: 20px 0;
     padding: 10px 0;
     border-top: 1px solid #eee;
     border-bottom: 1px solid #eee;
   }
   
   .payment-info p {
     margin: 5px 0;
     font-size: 14px;
   }
   
   .address-section {
     display: flex;
     flex-wrap: wrap;
     justify-content: space-between;
     margin: 20px 0;
   }
   
   .address-block {
     width: 30%;
     margin-bottom: 20px;
   }
   
   .address-block h3 {
     margin-top: 0;
     margin-bottom: 10px;
     font-size: 16px;
     color: #444;
   }
   
   .address-block p {
     margin: 3px 0;
     font-size: 13px;
   }
   
   .supply-details {
     margin: 20px 0;
   }
   
   .supply-details p {
     margin: 5px 0;
     font-size: 14px;
   }
   
   .signature {
     margin-top: 40px;
     text-align: right;
   }
   
   .signature-line {
     width: 200px;
     height: 1px;
     background-color: #000;
     margin: 40px 0 10px auto;
   }
   
   @media print {
     .invoice-container {
       box-shadow: none;
       border: none;
       margin: 0;
       padding: 0;
     }
     
     @page {
       size: A4;
       margin: 10mm;
     }
   }
 `;

      // Use the HTML data from singleEntity or generate new HTML if not available
      const htmlData =
         // singleEntity.htmlData ||
         `
 <!DOCTYPE html>
 <html>
 <head>
   <title>Invoice - ${singleEntity.docno || ''}</title>
   <meta charset="UTF-8">
   <meta name="viewport" content="width=device-width, initial-scale=1.0">
   <style>
     ${cssData}
   </style>
 </head>
 <body>
   <div class="invoice-container">
     <div class="header">
       <h1>${singleEntity.companyname || ''}</h1>
       <p>${singleEntity.accAdd2 || ''}</p>
       <p>
         Mobile: ${singleEntity.compMobile || ''}  Email: ${singleEntity.accEmail || '-'}
       </p>
       <p>
         Pan: ${singleEntity.companyPan || ''}  Warehouse: ${singleEntity.warehousename || '-'}
       </p>
     </div>
 
     <div class="invoice-details">
       <div class="left-details">
         <p>Daybook: ${singleEntity.daybookname || ''}</p>
         <p>Order Date: ${formattedTransactionDate}</p>
       </div>
       <div class="right-details">
         <p>Doc Number: ${singleEntity.docno || ''}</p>
         <p>Account Name: ${singleEntity.accountname || ''}</p>
         <p>Invoice Date: ${formattedCreatedAtnDate}</p>
       </div>
     </div>
 
     <div class="line-items">
       <table class="items-table">
         <thead>
           <tr>
             <th>Sl. No</th>
             <th>Description</th>
             <th>Unit Price</th>
             <th>Qty</th>
             <th>Net Amount</th>
             <th>Tax Rate</th>
             <th>Tax Type</th>
             <th>Tax Amount</th>
             <th>Total Amount</th>
           </tr>
         </thead>
         <tbody>
           ${
              singleEntity.lineitems && singleEntity.lineitems.length > 0
                 ? singleEntity.lineitems
                      .map(
                         (item, index) => `
                     <tr>
                       <td>${item.lineNumber || index + 1}</td>
                       <td>${item.itemName || ''}</td>
                       <td>${formatCurrency(item.itemRate)}</td>
                       <td>${item.qty1 || 0}</td>
                       <td>${formatCurrency(item.netAmount)}</td>
                       <td>${getTaxRate(item)}</td>
                       <td>${getTaxType(item)}</td>
                       <td>${getTaxAmount(item)}</td>
                       <td>${formatCurrency(item.netAmount)}</td>
                     </tr>
                   `,
                      )
                      .join('')
                 : `<tr><td colspan="9">No items found</td></tr>`
           }
         </tbody>
         <tfoot>
           <tr class="total-row">
             <td colspan="7" class="total-label">TOTAL:</td>
             <td>${formatCurrency(totals.totalTaxAmount)}</td>
             <td>${formatCurrency(singleEntity.basicAmount)}</td>
           </tr>
         </tfoot>
       </table>
     </div>
 
     <div class="terms-section">
       <table class="terms-table">
         <thead>
           <tr>
             <th>Description</th>
             <th>Term Description</th>
             <th>Value/Percentage</th>
             <th>Amount</th>
           </tr>
         </thead>
         <tbody>
           ${
              singleEntity.salebillterms && singleEntity.salebillterms.length > 0
                 ? singleEntity.salebillterms
                      .map(
                         (term) => `
                     <tr>
                       <td>${term.termDescription || term.billTermDescription || ''}</td>
                       <td>${term.termDescription || ''}</td>
                       <td>${
                          term.methodOfCalcName === 'Value'
                             ? formatCurrency(Math.abs(term.amount))
                             : `${term.percentage}%`
                       }</td>
                       <td>${formatCurrency(term.amount)}</td>
                     </tr>
                   `,
                      )
                      .join('')
                 : `<tr><td colspan="4">No bill terms found</td></tr>`
           }
         </tbody>
         <tfoot>
           <tr>
             <td colspan="3" class="amount-label">Basic Amount:</td>
             <td>${formatCurrency(singleEntity.basicAmount)}</td>
           </tr>
           <tr>
             <td colspan="3" class="amount-label">Total Deductions:</td>
             <td>${formatCurrency(-singleEntity.deductionAmount)}</td>
           </tr>
           <tr>
             <td colspan="3" class="amount-label">Net Amount:</td>
             <td>${formatCurrency(singleEntity.netAmount)}</td>
           </tr>
         </tfoot>
       </table>
     </div>
 
     <div class="amount-words">
       <p id="notes">Notes: ${singleEntity.notes}</p>
     </div>
     <div class="amount-words">
       <p>Amount in Words: ${amountInWords(totals.grandTotal)}</p>
       <p>Whether tax is payable under reverse charge: No</p>
     </div>
 
     <div class="payment-details">
       <div class="payment-info">
         <p>Payment Transaction ID: ${singleEntity.transactionId || ''}</p>
         <p>Date & Time: ${singleEntity.paymentDateTime || ''}</p>
         <p>Invoice Value: ${singleEntity.netAmount}</p>
         <p>Mode of Payment: ${singleEntity.paymentMode || ''}</p>
       </div>
     </div>
 
     <div class="address-section">
       <div class="address-block">
         <h3>Sold By:</h3>
         <p>${singleEntity.companyname || 'PARMAR ENTERPRISE'}</p>
         <p>${
            singleEntity.companyAddress1 ||
            '95, Ground floor, Ambika Industries, Opp RKLP Textile Market, Near Bharat Cancer Hospital, Kadodra Road, Saroli'
         }</p>
         <p>${singleEntity.companyCity || 'SURAT'}, ${singleEntity.companyState || 'GUJARAT'}, ${
            singleEntity.companyPincode || '395010'
         }</p>
         <p>${singleEntity.companyCountry || 'IN'}</p>
         <p>PAN No: ${singleEntity.companyPan || 'CIQPP5312L'}</p>
         <p>GST Registration No: ${singleEntity.companyGst || '24CIQPP5312L1ZV'}</p>
       </div>
 
       <div class="address-block">
         <h3>Billing Address:</h3>
         <p>${singleEntity.companyname || 'PARMAR ENTERPRISE'}</p>
         <p>${
            singleEntity.companyAddress1 ||
            '95, Ground floor, Ambika Industries, Opp RKLP Textile Market, Near Bharat Cancer Hospital, Kadodra Road, Saroli'
         }</p>
         <p>${singleEntity.companyCity || 'SURAT'}, ${singleEntity.companyState || 'GUJARAT'}, ${
            singleEntity.companyPincode || '395010'
         }</p>
         <p>${singleEntity.companyCountry || 'IN'}</p>
         <p>PAN No: ${singleEntity.companyPan || 'CIQPP5312L'}</p>
         <p>GST Registration No: ${singleEntity.companyGst || '24CIQPP5312L1ZV'}</p>
       </div>
 
       <div class="address-block">
         <h3>Shipping Address:</h3>
         <p>${singleEntity.shippingName || ''}</p>
         <p>${singleEntity.shippingAddress || ''}</p>
         <p>${singleEntity.shippingCity || ''}, ${singleEntity.shippingState || ''}, ${
            singleEntity.shippingPincode || ''
         }</p>
         <p>${singleEntity.shippingCountry || 'IN'}</p>
         <p>State/UT Code: ${singleEntity.shippingStateCode || ''}</p>
       </div>
     </div>
 
     <div class="supply-details">
       <p>Place of supply: ${singleEntity.placeOfSupply || ''}</p>
       <p>Place of delivery: ${singleEntity.placeOfDelivery || ''}</p>
     </div>
 
     <div class="signature">
       <p>For ${singleEntity.companyname || 'PARMAR ENTERPRISE'}:</p>
       <div class="signature-line"></div>
       <p>Authorized Signatory</p>
     </div>
   </div>
 </body>
 </html>
 `;

      // Create a temporary iframe to render the HTML
      const printAndGeneratePDF = (htmlContent) => {
         // Extract CSS from HTML content
         const cssStyles = cssData; // Use the existing cssData variable

         // First approach: Print directly using browser print functionality
         const printDirectly = () => {
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            iframe.contentDocument.open();
            iframe.contentDocument.write(htmlContent);
            iframe.contentDocument.close();

            // Wait for all resources to load before printing
            iframe.onload = () => {
               try {
                  iframe.contentWindow.print();
                  // Remove the iframe after printing (or after a delay to ensure printing completes)
                  setTimeout(() => {
                     document.body.removeChild(iframe);
                  }, 1000);
               } catch (error) {
                  console.error('Error printing:', error);
                  document.body.removeChild(iframe);
               }
            };
         };

         // Second approach: Generate PDF using jsPDF and html2canvas
         const generatePDF = async () => {
            try {
               // Check if the libraries are loaded
               if (!window.html2canvas || !window.jspdf) {
                  await loadPDFLibraries();
               }

               const { jsPDF } = window.jspdf;

               // Create a clean document viewer
               const printWindow = window.open('', '_blank');
               if (!printWindow) {
                  alert('Please allow pop-ups to generate the PDF');
                  return;
               }

               // Write the complete HTML with CSS to the new window
               printWindow.document.write(`
           <!DOCTYPE html>
           <html>
           <head>
             <title>Invoice - ${singleEntity.docno || ''}</title>
             <meta charset="UTF-8">
             <meta name="viewport" content="width=device-width, initial-scale=1.0">
             <style>${cssStyles}</style>
           </head>
           <body>
             <div class="invoice-container">
               ${
                  printWindow.document.documentElement.querySelector('.invoice-container')
                     ? printWindow.document.documentElement.querySelector('.invoice-container').innerHTML
                     : htmlContent.match(/<div class="invoice-container">([\s\S]*?)<\/div>/)?.[1] || htmlContent
               }
             </div>
             <script>
               document.addEventListener('DOMContentLoaded', function() {
                 // Alert to let us know DOM is ready
                 window.isReady = true;
               });
             </script>
           </body>
           </html>
         `);

               // Give the window time to render the content
               setTimeout(async () => {
                  try {
                     const invoiceContainer = printWindow.document.querySelector('.invoice-container');

                     if (!invoiceContainer) {
                        throw new Error('Could not find invoice container in the document');
                     }

                     // Create a new PDF document in A4 format
                     const pdf = new jsPDF('p', 'pt', 'a4');
                     const pageWidth = pdf.internal.pageSize.getWidth();
                     const pageHeight = pdf.internal.pageSize.getHeight();

                     // Capture HTML content as an image using html2canvas
                     const canvas = await html2canvas(invoiceContainer, {
                        scale: 2, // Higher scale for better quality
                        logging: false,
                        useCORS: true,
                        windowWidth: invoiceContainer.scrollWidth,
                     });

                     // Calculate the number of pages needed
                     const imgHeight = (canvas.height * pageWidth) / canvas.width;
                     const totalPages = Math.ceil(imgHeight / pageHeight);

                     // Add each page to the PDF
                     let position = 0;

                     // For the first page
                     pdf.addImage(
                        canvas.toDataURL('image/png', 1.0),
                        'PNG',
                        0,
                        position,
                        pageWidth,
                        (pageWidth * canvas.height) / canvas.width,
                     );

                     // For additional pages if content is longer than one page
                     for (let i = 1; i < totalPages; i++) {
                        position -= pageHeight;
                        pdf.addPage();
                        pdf.addImage(
                           canvas.toDataURL('image/png', 1.0),
                           'PNG',
                           0,
                           position,
                           pageWidth,
                           (pageWidth * canvas.height) / canvas.width,
                        );
                     }

                     // Save the PDF
                     const fileName = `Invoice-${singleEntity.docno || 'Document'}-${new Date()
                        .toISOString()
                        .slice(0, 10)}.pdf`;
                     pdf.save(fileName);

                     // Close the temp window
                     printWindow.close();
                  } catch (error) {
                     console.error('Error generating PDF:', error);
                     alert(`Error generating PDF: ${error.message}`);
                     printWindow.close();
                  }
               }, 1000); // Increased timeout to allow proper rendering
            } catch (error) {
               console.error('PDF generation failed:', error);
               alert('PDF generation failed. Please try again or use the print function instead.');
            }
         };

         // Function to load necessary libraries if they're not already loaded
         const loadPDFLibraries = () => {
            return new Promise((resolve, reject) => {
               // Load html2canvas if not already loaded
               if (!window.html2canvas) {
                  const html2canvasScript = document.createElement('script');
                  html2canvasScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
                  html2canvasScript.onload = () => {
                     // After html2canvas is loaded, load jsPDF
                     if (!window.jspdf) {
                        const jsPDFScript = document.createElement('script');
                        jsPDFScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
                        jsPDFScript.onload = resolve;
                        jsPDFScript.onerror = reject;
                        document.head.appendChild(jsPDFScript);
                     } else {
                        resolve();
                     }
                  };
                  html2canvasScript.onerror = reject;
                  document.head.appendChild(html2canvasScript);
               }
               // If html2canvas is loaded but jsPDF is not
               else if (!window.jspdf) {
                  const jsPDFScript = document.createElement('script');
                  jsPDFScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
                  jsPDFScript.onload = resolve;
                  jsPDFScript.onerror = reject;
                  document.head.appendChild(jsPDFScript);
               }
               // Both are already loaded
               else {
                  resolve();
               }
            });
         };

         // Create action buttons for printing and generating PDF
         const showActionButtons = () => {
            // Create a container for the buttons
            const actionContainer = document.createElement('div');
            actionContainer.style.position = 'fixed';
            actionContainer.style.top = '20px';
            actionContainer.style.right = '20px';
            actionContainer.style.zIndex = '9999';
            actionContainer.style.display = 'flex';
            actionContainer.style.flexDirection = 'column';
            actionContainer.style.gap = '10px';

            // Create Print button
            const printButton = document.createElement('button');
            printButton.textContent = 'Print Invoice';
            printButton.style.padding = '10px 15px';
            printButton.style.backgroundColor = '#4CAF50';
            printButton.style.color = 'white';
            printButton.style.border = 'none';
            printButton.style.borderRadius = '4px';
            printButton.style.cursor = 'pointer';
            printButton.onclick = printDirectly;

            // Create PDF button
            const pdfButton = document.createElement('button');
            pdfButton.textContent = 'Generate PDF';
            pdfButton.style.padding = '10px 15px';
            pdfButton.style.backgroundColor = '#2196F3';
            pdfButton.style.color = 'white';
            pdfButton.style.border = 'none';
            pdfButton.style.borderRadius = '4px';
            pdfButton.style.cursor = 'pointer';
            pdfButton.onclick = generatePDF;

            // Create Close button
            const closeButton = document.createElement('button');
            closeButton.textContent = 'Close Preview';
            closeButton.style.padding = '10px 15px';
            closeButton.style.backgroundColor = '#f44336';
            closeButton.style.color = 'white';
            closeButton.style.border = 'none';
            closeButton.style.borderRadius = '4px';
            closeButton.style.cursor = 'pointer';
            closeButton.onclick = () => {
               document.body.removeChild(previewContainer);
               document.body.removeChild(actionContainer);
               document.body.style.overflow = 'auto';
            };

            // Add buttons to container
            actionContainer.appendChild(printButton);
            actionContainer.appendChild(pdfButton);
            actionContainer.appendChild(closeButton);

            // Add container to body
            document.body.appendChild(actionContainer);

            return actionContainer;
         };

         // Create a preview iframe for proper CSS rendering
         const previewContainer = document.createElement('div');
         previewContainer.style.position = 'fixed';
         previewContainer.style.top = '0';
         previewContainer.style.left = '0';
         previewContainer.style.width = '100%';
         previewContainer.style.height = '100%';
         previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
         previewContainer.style.zIndex = '9998';
         previewContainer.style.overflow = 'auto';
         previewContainer.style.padding = '50px';

         // Create an iframe for better style isolation
         const previewFrame = document.createElement('iframe');
         previewFrame.style.width = '100%';
         previewFrame.style.height = '100vh';
         previewFrame.style.border = 'none';
         previewFrame.style.backgroundColor = 'white';
         previewFrame.style.borderRadius = '5px';

         previewContainer.appendChild(previewFrame);
         document.body.appendChild(previewContainer);

         // Write content to the iframe with proper styling
         previewFrame.contentWindow.document.open();
         previewFrame.contentWindow.document.write(`
       <!DOCTYPE html>
       <html>
       <head>
         <title>Invoice Preview</title>
         <meta charset="UTF-8">
         <meta name="viewport" content="width=device-width, initial-scale=1.0">
         <style>${cssStyles}</style>
       </head>
       <body style="margin:0; padding:0;">
         ${htmlContent.match(/<body>([\s\S]*?)<\/body>/)?.[1] || htmlContent}
       </body>
       </html>
     `);
         previewFrame.contentWindow.document.close();

         // Prevent scrolling on the body
         document.body.style.overflow = 'hidden';

         // Show action buttons
         showActionButtons();
      };

      // Show the preview and action buttons
      printAndGeneratePDF(htmlData);
   };

   const saveReason = useCallback(
      async (e) => {
         e.preventDefault();

         if (entityType === 'receivemaster') {
            const payload = {
               rldId: lineDetailId,
               reason: reason,
               returnDate: returnDate,
            };
            await dispatch(addReceiveReason(payload));
         }
         if (entityType === 'issuemaster') {
            const payload = {
               ildId: lineDetailId,
               reason: reason,
               returnDate: returnDate,
            };
            await dispatch(addIssueReason(payload));
         }
         setReason('');
         setReturnDate('');
         setLineDetailId(null);
         onCloseReturn();
         onClose();
      },
      [dispatch, entityType, lineDetailId, onClose, onCloseReturn, reason, returnDate],
   );

   return (
      <>
         <Modal isOpen={isOpenSingleView} onClose={onClose} size="6xl">
            <ModalOverlay />
            <ModalContent borderRadius="lg" boxShadow="2xl">
               <Flex position="absolute" left="-10%" top="50%" transform="translateX(-50%)" gap={4}>
                  <Button variant="ghost" bg={'gray.300'} w={12} h={12} borderRadius="50%" onClick={handlePrevious}>
                     <GrFormPrevious size={22} />
                  </Button>
               </Flex>
               <Flex position="absolute" right="-10%" top="50%" transform="translateX(50%)" gap={4}>
                  <Button variant="ghost" bg={'gray.300'} w={12} h={12} borderRadius="50%" onClick={handleNext}>
                     <GrFormNext size={22} />
                  </Button>
               </Flex>
               <ModalHeader>
                  <Flex alignItems={'center'}>
                     <HStack>
                        <Box>
                           <Text fontSize="28px" fontWeight="bold">
                              {title}#{dynamicArray[0].value}
                           </Text>
                        </Box>
                        <Flex position="absolute" right="12" top="4">
                           <img src={about} alt="about" width="18px" height="18px" />
                           {(Admin || singleEntityRights?.edit) && (
                              <Box
                                 cursor="pointer"
                                 onClick={handleEditClick}
                                 _hover={{ bg: 'gray.200', variant: 'ghost', borderRadius: '50px' }}
                                 p="10px"
                                 title="Edit">
                                 <img src={editIcon} alt="Edit" width={23} />
                              </Box>
                           )}
                           <Menu>
                              <MenuButton
                                 as={Box}
                                 cursor="pointer"
                                 _hover={{ bg: 'gray.200', borderRadius: '50px' }}
                                 p="10px"
                                 title="Receipt">
                                 <img src={receiptIcon} alt="receipt" width={23} />
                              </MenuButton>
                              <MenuList p={3}>
                                 <Menu placement="right-start" closeOnSelect={false}>
                                    <MenuButton
                                       as={MenuItem}
                                       fontSize="md"
                                       fontWeight="bold"
                                       rightIcon={<FaChevronRight />}>
                                       Bank
                                    </MenuButton>
                                    <MenuList p={3}>
                                       <MenuItem fontSize="md" fontWeight="bold" onClick={handleBankPaymentClick}>
                                          Bank Payment
                                       </MenuItem>
                                       <MenuItem fontSize="md" fontWeight="bold" onClick={handleBankReceiveClick}>
                                          Bank Receive
                                       </MenuItem>
                                    </MenuList>
                                 </Menu>
                                 <Menu placement="right-start" closeOnSelect={false}>
                                    <MenuButton
                                       as={MenuItem}
                                       fontSize="md"
                                       fontWeight="bold"
                                       rightIcon={<FaChevronRight />}>
                                       Cash
                                    </MenuButton>
                                    <MenuList p={3}>
                                       <MenuItem fontSize="md" fontWeight="bold" onClick={handleCashPaymentClick}>
                                          Cash Payment
                                       </MenuItem>
                                       <MenuItem fontSize="md" fontWeight="bold" onClick={handleCashReceiveClick}>
                                          Cash Receive
                                       </MenuItem>
                                    </MenuList>
                                 </Menu>
                              </MenuList>
                           </Menu>
                           <Box
                              cursor="pointer"
                              _hover={{ bg: 'gray.200', variant: 'ghost', borderRadius: '50px' }}
                              p="10px"
                              title="Copy">
                              <img src={copyIcon} alt="copy" width={23} />
                           </Box>
                           <Box
                              cursor="pointer"
                              _hover={{ bg: 'gray.200', variant: 'ghost', borderRadius: '50px' }}
                              p="10px"
                              title="Share">
                              <img src={shareIcon} alt="Share" width={23} />
                           </Box>
                           <Box
                              cursor="pointer"
                              _hover={{ bg: 'gray.200', variant: 'ghost', borderRadius: '50px' }}
                              p="10px"
                              title="Print"
                              onClick={() => handlePrintClick(singleEntity)}>
                              <img src={printIcon} alt="Print" width={23} />
                           </Box>
                           <Box
                              cursor="pointer"
                              _hover={{ bg: 'gray.200', variant: 'ghost', borderRadius: '50px' }}
                              p="10px"
                              onClick={handleBarcodePrint}
                              title="Print Barcodes"
                              position="relative">
                              <img src={dwonloadIcon} alt="Download" width={23} />
                              {selectedBarcodeItems.length > 0 && (
                                 <Badge
                                    colorScheme="blue"
                                    borderRadius="full"
                                    position="absolute"
                                    top="-5px"
                                    right="-5px"
                                    fontSize="xs">
                                    {selectedBarcodeItems.length}
                                 </Badge>
                              )}
                           </Box>
                           {/* <Box
                              cursor="pointer"
                              _hover={{ bg: 'gray.200', variant: 'ghost', borderRadius: '50px' }}
                              p="10px"
                              onClick={handleBarcodePrint}
                              title="Download">
                              <img src={dwonloadIcon} alt="Download" width={23} />
                           </Box> */}
                           <Menu>
                              <MenuButton
                                 as={Box}
                                 cursor="pointer"
                                 _hover={{
                                    bg: 'gray.200',
                                    variant: 'ghost',
                                    borderRadius: '50px',
                                 }}
                                 p="10px"
                                 title="menu">
                                 <img src={dotIcon} alt="Menu" width={23} />
                              </MenuButton>
                              <MenuList p={3}>
                                 <MenuItem onClick={handleCreateNote} fontSize={'md'} fontWeight={'bold'}>
                                    Credit Note
                                 </MenuItem>
                                 {(Admin || singleEntityRights?.edit) && (
                                    <MenuItem
                                       onClick={() => setIsDeleteDialogOpen(true)}
                                       fontSize={'md'}
                                       fontWeight={'bold'}>
                                       Delete
                                    </MenuItem>
                                 )}
                              </MenuList>
                           </Menu>
                        </Flex>
                     </HStack>
                     <ModalCloseButton color="gray" size={25} mt={2} p={3} />
                  </Flex>
               </ModalHeader>
               <ModalBody p={5}>
                  <Flex>
                     <Box width={'800px'} p="4" borderWidth="2px" borderRadius={'md'} mr={'10px'}>
                        <Text fontSize="lg" fontWeight="" mb={3}>
                           {dynamicUserDetails.map((detail, index) => (
                              <Text key={index}>
                                 {detail.label} : {detail.value}
                              </Text>
                           ))}
                        </Text>
                     </Box>
                     <Box>
                        <Box
                           width={'300px'}
                           p="4"
                           mb="10px"
                           borderWidth="2px"
                           borderColor="border.disabled"
                           color="fg.disabled"
                           borderRadius={'md'}>
                           <Text fontSize="sm" fontWeight="bold" mb={2} textTransform="uppercase">
                              Net Payable
                           </Text>
                           <Flex alignItems={'center'}>
                              <FaRupeeSign size={13} />
                              <Text fontSize="lg" fontWeight="bold" mr={2}>
                                 {calculateTotal(
                                    dynamicItemDetails[1].value,
                                    dynamicItemDetails[2].value,
                                    dynamicItemDetails[3].value,
                                 )}
                                 .00
                              </Text>
                              {dynamicArray?.paymentStatus === 'pending' ? (
                                 <Badge colorScheme="orange" borderRadius={4} fontSize="10px" mb={''}>
                                    Pending
                                 </Badge>
                              ) : (
                                 <Badge colorScheme="green" borderRadius={4} fontSize="10px" mb={''}>
                                    Received
                                 </Badge>
                              )}
                           </Flex>
                        </Box>
                        <Box
                           width={'300px'}
                           p="4"
                           borderWidth="2px"
                           borderColor="border.disabled"
                           color="fg.disabled"
                           borderRadius={'md'}>
                           <div>
                              <Text fontSize="14px" fontWeight="semibold" mb={2}>
                                 Invoice details
                              </Text>
                              {dynamicArray.map((item, index) => (
                                 <Text key={index} fontSize="17px" mb={1}>
                                    {item.label} : {item.value}
                                 </Text>
                              ))}
                           </div>
                        </Box>
                     </Box>
                  </Flex>
                  <TableContainer width={'full'} p="4" borderWidth="2px" mt={12} borderRadius={'md'}>
                     <Table>
                        <Thead borderBottom={'2px'} borderColor="gray.200">
                           <Tr>
                              <Th>
                                 <Flex alignItems="center">
                                    <Checkbox
                                       isChecked={
                                          selectedBarcodeItems.length === getTotalBarcodeItems() &&
                                          getTotalBarcodeItems() > 0
                                       }
                                       onChange={handleSelectAll}
                                       size="md"
                                       mr={2}
                                    />
                                    <Text>Select</Text>
                                 </Flex>
                              </Th>
                              <Th>Sl No</Th>
                              <Th>Item</Th>
                              <Th>Serial No</Th>
                              <Th>Qty</Th>
                              <Th>Rate</Th>
                              {/* <Th>Discount</Th>
                              <Th>Total</Th> */}
                              {title === 'Receive' && <Th>Status</Th>}
                           </Tr>
                        </Thead>
                        <Tbody>
                           {/* {singleEntity.lineitems?.map((item, index) => ( */}
                           {singleEntity.lineitems?.map((item, index) => {
                              // Get serial numbers from purchaseLineDetail if they exist
                              const lineDetailKey =
                                 entityType === 'issuemaster' ? 'issueLineDetail' : 'receiveLineDetail';
                              const lineDetails = item[lineDetailKey] || [];

                              const hasSerialNumbers =
                                 item?.purchaseLineDetail &&
                                 Array.isArray(item.purchaseLineDetail) &&
                                 item.purchaseLineDetail.length > 0;
                              return lineDetails?.length > 0 ? (
                                 lineDetails?.map((subdata, subIndex) => (
                                    <Tr key={`${index}-${subIndex}`} borderBottom={'2px'} borderColor="gray.200">
                                       <Td>
                                          {hasSerialNumbers && (
                                             <Box>
                                                {item.purchaseLineDetail.map(
                                                   (detail, detailIndex) =>
                                                      detail?.serialNo && (
                                                         <Checkbox
                                                            key={detailIndex}
                                                            isChecked={isItemSelected(detail.serialNo)}
                                                            onChange={() =>
                                                               handleCheckboxChange(
                                                                  detail.serialNo,
                                                                  detail.serialNo,
                                                                  detail.barcode,
                                                                  item.id || `${index}-${detailIndex}`,
                                                                  item.itemName,
                                                               )
                                                            }
                                                            size="sm"
                                                            mb={
                                                               detailIndex < item.purchaseLineDetail.length - 1 ? 1 : 0
                                                            }
                                                         />
                                                      ),
                                                )}
                                             </Box>
                                          )}
                                       </Td>
                                       <Td>{index + 1}</Td>
                                       <Td>{item.itemName}</Td>
                                       <Td>
                                          <Flex>
                                             {subdata.serialNo}
                                             {lineDetailKey === 'receiveLineDetail' &&
                                                subdata.status !== 'SOLD' &&
                                                subdata?.returnStatus !== 'IS RETURN' && (
                                                   <Icon
                                                      as={FaHistory}
                                                      boxSize={4}
                                                      ml={3}
                                                      color="green.600"
                                                      onClick={() => {
                                                         setSelectedItem(item); // Store the item data
                                                         setIsIssuePurchaseModalOpen(true); // Open the modal
                                                         handleOnOpenModal(subdata.serialNo);
                                                      }}
                                                      cursor="pointer"
                                                   />
                                                )}
                                             {subdata.returnStatus === 'IS RETURN' ? (
                                                <Icon
                                                   as={DeleteIcon}
                                                   boxSize={4}
                                                   ml={3}
                                                   color="red.600"
                                                   onClick={async () => {
                                                      if (entityType === 'receivemaster') {
                                                         Swal.fire({
                                                            title: 'Are you sure?',
                                                            text: "You won't be able to revert this!",
                                                            icon: 'warning',
                                                            showCancelButton: true,
                                                            confirmButtonColor: '#3085d6',
                                                            cancelButtonColor: '#d33',
                                                            confirmButtonText: 'Yes, delete it!',
                                                         }).then(async (result) => {
                                                            if (result.isConfirmed) {
                                                               const payload = {
                                                                  rldId: subdata?.id,
                                                                  reason: subdata?.reason,
                                                                  isDeleted: true,
                                                               };
                                                               await dispatch(addReceiveReason(payload));
                                                               onClose();
                                                            }
                                                         });
                                                      }
                                                      if (entityType === 'issuemaster') {
                                                         Swal.fire({
                                                            title: 'Are you sure?',
                                                            text: "You won't be able to revert this!",
                                                            icon: 'warning',
                                                            showCancelButton: true,
                                                            confirmButtonColor: '#3085d6',
                                                            cancelButtonColor: '#d33',
                                                            confirmButtonText: 'Yes, delete it!',
                                                         }).then(async (result) => {
                                                            if (result.isConfirmed) {
                                                               const payload = {
                                                                  ildId: subdata?.id,
                                                                  reason: subdata?.reason,
                                                                  isDeleted: true,
                                                               };
                                                               await dispatch(addIssueReason(payload));
                                                               onClose();
                                                            }
                                                         });
                                                      }
                                                   }}
                                                   cursor="pointer"
                                                />
                                             ) : lineDetailKey !== 'receiveLineDetail' &&
                                               subdata?.returnStatus !== 'IS RETURN' ? (
                                                <Icon
                                                   as={FaHistory}
                                                   boxSize={4}
                                                   ml={3}
                                                   color="orange.600"
                                                   onClick={() => {
                                                      onOpenReturn();
                                                      setLineDetailId(subdata?.id);
                                                   }}
                                                   cursor="pointer"
                                                />
                                             ) : lineDetailKey === 'receiveLineDetail' &&
                                               subdata.status === 'RECEIVED_ONLY' &&
                                               subdata?.returnStatus !== 'IS RETURN' ? (
                                                <Icon
                                                   as={FaHistory}
                                                   boxSize={4}
                                                   ml={3}
                                                   color="orange.600"
                                                   onClick={() => {
                                                      onOpenReturn();
                                                      setLineDetailId(subdata?.id);
                                                   }}
                                                   cursor="pointer"
                                                />
                                             ) : null}
                                          </Flex>
                                       </Td>
                                       <Td>{item.qty1}</Td>
                                       <Td>{item.itemRate}</Td>
                                       {title === 'Receive' && (
                                          <Td
                                             minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                             height="30px"
                                             fontWeight={500}
                                             py={4}
                                             verticalAlign="middle"
                                             textAlign="center">
                                             <Badge
                                                border="1px solid"
                                                bg="transparent"
                                                borderColor="blue.400"
                                                color="blue.400"
                                                borderRadius="md"
                                                w="100%"
                                                textAlign="center"
                                                textTransform="capitalize">
                                                {subdata.status ? subdata.status : '-'}
                                             </Badge>
                                          </Td>
                                       )}
                                       {/* <Td>{subdata.status}</Td> */}
                                       {/* <Td>{singleEntity?.salebillteams[0]?.percentage || 0 }%</Td> */}
                                       {/* <Td>
                                       {calculateTotal(item.qty1, item.itemRate, singleEntity.salebillteams[0].percentage)}.00
                                    </Td> */}
                                    </Tr>
                                 ))
                              ) : (
                                 <Tr key={index} borderBottom="2px" borderColor="gray.200">
                                    <Td> {/* You can include the same checkbox code here if needed */} </Td>
                                    <Td>{index + 1}</Td>
                                    <Td>{item.itemName}</Td>
                                    <Td>-</Td>
                                    <Td>{item.qty1}</Td>
                                    <Td>{item.itemRate}</Td>
                                    {/* <Td>{billTerms?.[0]?.percentage || 0}%</Td>
                                    <Td>
                                       {calculateTotal(item.qty1, item.itemRate, billTerms?.[0]?.percentage || 0)}.00
                                    </Td> */}
                                 </Tr>
                              );
                           })}
                           <Tr>
                              <Td>
                                 <Text fontSize="sm" fontWeight="">
                                    Total:
                                 </Text>
                              </Td>
                              <Td colSpan={2} />
                              <Td display={'flex'}>
                                 <Text fontSize="sm" fontWeight="" ml={2}>
                                    {singleEntity.lineitems?.reduce((acc, item) => acc + item.qty1, 0)}
                                 </Text>
                              </Td>
                              <Td></Td>
                           </Tr>
                        </Tbody>
                     </Table>
                  </TableContainer>
                  <Flex mt={4} justifyContent="space-between" alignItems="center">
                     <Box />
                     <Box textAlign="right" display={'flex'} gap={10}>
                        <Text fontSize="17px" fontWeight="500" mr={5}>
                           Net Payable
                        </Text>
                        <Text fontSize="16px" fontWeight="bold">
                           ₹{' '}
                           {singleEntity.lineitems
                              ?.reduce((acc, item) => acc + item.qty1 * item.itemRate, 0)
                              .toFixed(2)}
                        </Text>
                     </Box>
                  </Flex>
               </ModalBody>
               <ModalFooter justify="space-between" align="center">
                  <Button variant="ghost" onClick={onClose} mt={4}>
                     Cancel
                  </Button>
               </ModalFooter>
               <IssuePurchaseEntriesModal
                  isOpen={isIssuePurchaseModalOpen}
                  onClose={() => {
                     setIsIssuePurchaseModalOpen(false);
                  }}
                  item={singleEntity}
                  subItem={selectedItem}
                  serialNo={serialNo}
                  onSave={handlesave}
                  type={'receive'}
               />
            </ModalContent>
         </Modal>
         {isOpenPaymentForm && (
            <PaymentcaseForm
               isOpen={isOpenPaymentForm}
               onClose={() => setIsOpenPaymentForm(false)}
               transactionType={transactionType}
               isBankPageView={isBankPageView}
            />
         )}
         {isDeleteDialogOpen && (
            <AlertDialog
               isOpen={isDeleteDialogOpen}
               onClose={() => setIsDeleteDialogOpen(false)}
               leastDestructiveRef={cancelRef}>
               <AlertDialogOverlay>
                  <AlertDialogContent>
                     {/* Dynamically set the title */}
                     <AlertDialogHeader>Confirm Deletion</AlertDialogHeader>
                     <AlertDialogBody>
                        Are you sure you want to delete this? This action cannot be undone.
                     </AlertDialogBody>
                     <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={() => setIsDeleteDialogOpen(false)}>
                           Cancel
                        </Button>
                        <Button colorScheme="red" onClick={handleDeleteClick} ml={3}>
                           Delete
                        </Button>
                     </AlertDialogFooter>
                  </AlertDialogContent>
               </AlertDialogOverlay>
            </AlertDialog>
         )}

         {/* <Modal isOpen={isOpenReturn} onClose={onCloseReturn} isCentered>
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Add Return</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  <Stack spacing={3}>
                     <Input placeholder="Enter Reason" value={reason} onChange={(e) => setReason(e.target.value)} />
                     <Input
                        type="date"
                        placeholder="Enter Return Date"
                        value={returnDate}
                        onChange={(e) => setReturnDate(e.target.value)}
                     />
                  </Stack>
               </ModalBody>

               <ModalFooter>
                  <Button colorScheme="red" mr={3} onClick={onCloseReturn}>
                     Close
                  </Button>
                  <Button colorScheme="blue" onClick={saveReason}>
                     Save
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal> */}

         <Modal isOpen={isOpenReturn} onClose={onCloseReturn} isCentered>
            <ModalOverlay />
            <ModalContent
               className={`
      ${isDark ? 'bg-gray-900 border-2 border-gray-700 shadow-xl' : 'bg-white border-2 border-gray-200 shadow-2xl'}
      rounded-2xl overflow-hidden
    `}>
               {/* Header with gradient background */}
               <ModalHeader
                  className={`
        ${
           isDark
              ? 'bg-gradient-to-r from-blue-900 to-purple-900 text-white'
              : 'bg-gradient-to-r from-blue-600 to-purple-600 text-white'
        }
        py-4 text-lg font-bold
      `}>
                  Add Return
               </ModalHeader>

               <ModalCloseButton
                  className={`
        ${isDark ? 'text-white hover:bg-gray-700' : 'text-gray-700 hover:bg-gray-200'}
        mt-2 mr-2 p-1 rounded-full transition-colors
      `}
               />

               <ModalBody className="py-6">
                  <Stack spacing={4}>
                     <div className="space-y-2">
                        <label
                           className={`
              ${isDark ? 'text-gray-300' : 'text-gray-700'}
              text-sm font-medium
            `}>
                           Reason
                        </label>
                        <Input
                           placeholder="Enter Reason"
                           value={reason}
                           onChange={(e) => setReason(e.target.value)}
                           className={`
              ${
                 isDark
                    ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-400 focus:border-blue-500'
                    : 'bg-gray-50 border-gray-300 text-gray-900 placeholder-gray-500 focus:border-blue-500'
              }
              border-2 rounded-lg px-4 py-3 transition-all focus:ring-2 focus:ring-blue-200
            `}
                        />
                     </div>

                     <div className="space-y-2">
                        <label
                           className={`
              ${isDark ? 'text-gray-300' : 'text-gray-700'}
              text-sm font-medium
            `}>
                           Return Date
                        </label>
                        <Input
                           type="date"
                           placeholder="Enter Return Date"
                           value={returnDate}
                           onChange={(e) => setReturnDate(e.target.value)}
                           className={`
              ${
                 isDark
                    ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-400 focus:border-blue-500'
                    : 'bg-gray-50 border-gray-300 text-gray-900 placeholder-gray-500 focus:border-blue-500'
              }
              border-2 rounded-lg px-4 py-3 transition-all focus:ring-2 focus:ring-blue-200
            `}
                        />
                     </div>
                  </Stack>
               </ModalBody>

               <ModalFooter className="py-4 border-t border-gray-200 dark:border-gray-700">
                  <Button
                     colorScheme="red"
                     mr={3}
                     onClick={onCloseReturn}
                     className={`
          ${isDark ? 'bg-red-600 hover:bg-red-700 text-white' : 'bg-red-500 hover:bg-red-600 text-white'}
          px-6 py-2 rounded-lg font-semibold transition-colors shadow-md
        `}>
                     Close
                  </Button>
                  <Button
                     colorScheme="blue"
                     onClick={saveReason}
                     className={`
          ${isDark ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-blue-500 hover:bg-blue-600 text-white'}
          px-6 py-2 rounded-lg font-semibold transition-colors shadow-md
        `}>
                     Save
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal>
      </>
   );
};

export default SaleSingleDataView;
